module.exports = __webpack_public_path__ + "img/ring_r_skip_null_1.c47dbd61.png";